import { render, staticRenderFns } from "./briefcase-storage-info.html?vue&type=template&id=8f095f9c&scoped=true&external"
import script from "./briefcase-storage-info.js?vue&type=script&lang=js&external"
export * from "./briefcase-storage-info.js?vue&type=script&lang=js&external"
import style0 from "./briefcase-storage-info.scss?vue&type=style&index=0&id=8f095f9c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f095f9c",
  null
  
)

export default component.exports